import { render, staticRenderFns } from "./NewGsCalendarDayContent.vue?vue&type=template&id=78fa9237&scoped=true"
import script from "./NewGsCalendarDayContent.vue?vue&type=script&lang=js"
export * from "./NewGsCalendarDayContent.vue?vue&type=script&lang=js"
import style0 from "./NewGsCalendarDayContent.vue?vue&type=style&index=0&id=78fa9237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa9237",
  null
  
)

export default component.exports